module.exports = __webpack_public_path__ + "img/2-4.05fe59f.png";